/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_PrefsInputs */

const cs_clients_comm_prefs = /** @type {(inputs: Clients_Comm_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferované notifikace`)
};

const en_clients_comm_prefs = /** @type {(inputs: Clients_Comm_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification preferences`)
};

/**
* | output |
* | --- |
* | "Notification preferences" |
*
* @param {Clients_Comm_PrefsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_prefs = /** @type {((inputs?: Clients_Comm_PrefsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_PrefsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_prefs(inputs)
	return cs_clients_comm_prefs(inputs)
});